import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { formatPrice } from '../../../../utilities';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexRowCenterVertical,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP, TextSpan } from '../../../Defaults/Text';

interface Props {
  price: number | string;
  priceWithoutVat?: number | string;
  currency: string;
  oldPrice?: number;
}

function PriceInfo({ price, priceWithoutVat, oldPrice, currency }: Props) {
  return (
    <Wrapper>
      <Price>
        {price > 0
          ? formatPrice(Number(price), 'EUR')
          : __('Cena na vyžiadanie')}{' '}
        {/* {oldPrice && oldPrice > 0 ? (
          <OldPrice>{`${oldPrice} ${currency}`}</OldPrice>
        ) : null} */}
      </Price>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(28)};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  white-space: nowrap;
  ${({ theme }) => theme.mediab.m600`
  font-size: ${rem(14)};
  margin-bottom: 0;
  margin-top: ${rem(1)};
`}
`;

const OldPrice = styled(TextSpan)`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${rem(14)};
  font-weight: initial;
`;

export { PriceInfo };
